import { Eyebrow } from "../components/Reveal";
import { useTitle } from "../hooks/useTitle";

const LegalShell = ({ title, children, testid }) => (
  <div data-testid={testid}>
    <section className="bg-[#0A192F] relative overflow-hidden py-14 lg:py-20">
      <div className="absolute inset-0 hero-grid" />
      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Eyebrow light>Legal</Eyebrow>
        <h1 className="font-display font-extrabold tracking-tight text-white text-3xl sm:text-4xl mt-4">{title}</h1>
      </div>
    </section>
    <section className="py-14 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-sm text-[#334E68] leading-[1.9] space-y-6">
      {children}
    </section>
  </div>
);

export const Privacy = () => {
  useTitle("Privacy Policy");
  return (
  <LegalShell title="Privacy Policy" testid="privacy-page">
    <p>SterlingNest ("we", "our") respects your privacy. This policy explains how we handle information you share with us through this website.</p>
    <h2 className="font-display font-bold text-[#0A192F] text-lg">Information we collect</h2>
    <p>When you submit an enquiry, contact or career application form, we collect your name, mobile number, email address, location, course or service interest and any message you choose to share. Career applications may include your resume and LinkedIn profile.</p>
    <h2 className="font-display font-bold text-[#0A192F] text-lg">How we use it</h2>
    <p>We use this information only to respond to your enquiry, share course or service details you requested, process career applications and improve our programs. We do not sell your personal information to third parties.</p>
    <h2 className="font-display font-bold text-[#0A192F] text-lg">Consent</h2>
    <p>By submitting any form on this website, you consent to SterlingNest contacting you by phone, WhatsApp or email regarding courses and services.</p>
    <h2 className="font-display font-bold text-[#0A192F] text-lg">Data security & retention</h2>
    <p>Your data is stored securely and retained only as long as necessary for the purposes above. You may request correction or deletion of your data anytime by writing to info@sterlingnest.in.</p>
  </LegalShell>
  );
};

export const Terms = () => {
  useTitle("Terms & Conditions");
  return (
  <LegalShell title="Terms & Conditions" testid="terms-page">
    <p>By using this website, you agree to the following terms. Please read them carefully.</p>
    <h2 className="font-display font-bold text-[#0A192F] text-lg">Training services</h2>
    <p>SterlingNest provides practical accounting and taxation training. Course content, duration, batch schedules and fees are communicated at the time of admission and may be updated from time to time.</p>
    <h2 className="font-display font-bold text-[#0A192F] text-lg">No placement guarantee</h2>
    <p>We provide career-focused training, interview preparation and placement support. We do not guarantee employment, specific salary outcomes or job placement.</p>
    <h2 className="font-display font-bold text-[#0A192F] text-lg">Professional services</h2>
    <p>Mutual fund and insurance-related services are provided subject to applicable regulations. We do not guarantee investment returns. Loan assistance is limited to documentation and application support; approval remains subject to the respective lender's policies.</p>
    <h2 className="font-display font-bold text-[#0A192F] text-lg">Refunds & cancellations</h2>
    <p>Course fees once paid are eligible for refund or adjustment as per the batch-wise refund policy shared at the time of admission. Please contact us for details before enrolling.</p>
    <h2 className="font-display font-bold text-[#0A192F] text-lg">Contact</h2>
    <p>For any questions about these terms, write to info@sterlingnest.in or call +91 90764 00577.</p>
  </LegalShell>
  );
};
